import type { ITableSort } from "app/components/React/Table/types";

interface ISortTrackingEvent {
    /** Kept byte-identical to the legacy `SWReactTable` sort event so existing analytics keep matching. */
    name: string;
    /** Newer named-event attribute, dispatched as a custom attribute alongside the legacy name. */
    eventFullName: string;
}

/**
 * Builds the sort click event for every sortable column. Two names are emitted deliberately:
 * the legacy `Table/<Column>/<dir>` that dashboards already resolve, and the slash-delimited
 * `event_full_name` used by the newer tracking convention.
 */
export const getSortTrackingEvent = (
    column: string,
    sortDirection: ITableSort["sortDirection"],
): ISortTrackingEvent => ({
    name: `Table/${column}/${sortDirection}`,
    eventFullName: `Website Rankings/Sort/${column}/${sortDirection}`,
});
